<template>
  <div class="server-error flex-all-center">{{ getSentence }}</div>
</template>

<script>
export default {
  props: {
    lang: {
      type: String,
    },
  },
  // 503エラーも含める
  computed: {
    getSentence: function () {
      if (this.lang === "ja") {
        return "サーバーエラーが発生しました";
      }
      return "Internal Server Error";
    },
  },
};
</script>

<style scoped>
.server-error {
  height: calc(100vh - 286px);
}
</style>



// WEBPACK FOOTER //
// src/components/common/status/InternalServerError.vue